import React from "react";

export const chevronDirection = {
  down: "down",
  up: "up",
  left: "left",
  right: "right",
};

export const Chevron = ({
  useEmptyClasses = false,
  extraClasses,
  direction = chevronDirection.down,
  size = "small",
}) =>
  !useEmptyClasses ? (
    <div
      role="img"
      className={`mls-o-buttons__svg transform ${
        extraClasses ? extraClasses : ""
      }`}
    >
      <span
        className={`oc-o-icon--chevron-${direction} fa-icon-svg fa-icon-svg--${size}`}
      >
        <svg
          className="fa-icon-svg fa-icon-svg--chevron-down"
          viewBox="0 0 30 30"
        >
          <use xlinkHref="#chevron-down" />
        </svg>
      </span>
    </div>
  ) : (
    <div role="img" className={extraClasses ? extraClasses : ""}>
      <svg viewBox="0 0 30 30">
        <use xlinkHref="#chevron-down" />
      </svg>
    </div>
  );

export const Filters = ({ extraClasses, size = "small" }) => (
  <div
    role="img"
    className={`mls-o-svg transform ${extraClasses ? extraClasses : ""}`}
  >
    <span className={`oc-o-icon--filters fa-icon-svg fa-icon-svg--${size}`}>
      <svg className="fa-icon-svg fa-icon-svg--filters" viewBox="0 0 23 23">
        <g fill="none" fillRule="evenodd">
          <path d="M.6.6h21.6v21.6H.6z" />
          <g stroke="#000" transform="translate(4.2 4.2)">
            <path strokeLinecap="square" d="M1.8.2v3m0 2.4v8.3" />
            <circle cx={1.8} cy={4.4} r={1} />
            <path strokeLinecap="square" d="M7.2 11.2v2.7M7.2.2v7.9" />
            <circle cx={7.2} cy={9.7} r={1} />
            <path strokeLinecap="square" d="M12.7.2v3m0 2.4v8.3" />
            <circle cx={12.7} cy={4.4} r={1} />
          </g>
        </g>
      </svg>
    </span>
  </div>
);

export const NoResults = ({ extraClasses, size = "large" }) => (
  <div
    role="img"
    className={`mls-o-svg transform ${extraClasses ? extraClasses : ""}`}
  >
    <span className={`oc-o-icon--no-results fa-icon-svg fa-icon-svg--${size}`}>
      <svg className="fa-icon-svg fa-icon-svg--no-results" viewBox="0 0 159 87">
        <g fill="none" fillRule="evenodd">
          <path
            className="fa-icon-svg__ball"
            stroke="#000"
            strokeWidth={5}
            d="M156.2 20a14.6 14.6 0 11-29.2 0 14.6 14.6 0 0129.2 0zm-34 17.5L74.9 85m47.5-27.5L94.8 85"
          />
          <path
            className="fa-icon-svg__goal"
            fill="#000"
            d="M6 0L0 6v50.8h.2L5 52V5h83.3v51.8h.1l4.9-4.9V0z"
          />
        </g>
      </svg>
    </span>
  </div>
);

export const MediaPlayingSVG = ({ extraClasses, size = "large" }) => (
  <div
    role="img"
    className={`mls-o-svg transform ${extraClasses ? extraClasses : ""}`}
  >
    <span
      className={`oc-o-icon--media-playing fa-icon-svg fa-icon-svg--${size}`}
    >
      <svg viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <path d="M-6-6h20v20H-6z" />
          <path
            fill="#FFF"
            d="M.67 2H2v6H.67zM3.33 0h1.34v8H3.33zM6 4h1.33v4H6z"
          />
          <g>
            <path d="M-6-6h20v20H-6z" />
            <path
              fill="#FFF"
              d="M.67 2H2v6H.67zM3.33 0h1.34v8H3.33zM6 4h1.33v4H6z"
            />
          </g>
        </g>
      </svg>
    </span>
  </div>
);

export const CardBackground = ({ extraClasses }) => (
  <div className={extraClasses}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMinYMin slice"
      viewBox="0 0 329 218"
    >
      <defs>
        <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#FBFBFB" />
          <stop offset="100%" stopColor="#F5F6F6" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#F5F6F6" stopOpacity="0" />
          <stop offset="100%" stopColor="#FBFBFB" />
        </linearGradient>
        <path id="a" d="M0 0h327v218H0z" />
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(1)">
        <mask id="c" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <use fill="#E5E6E6" fillRule="nonzero" xlinkHref="#a" />
        <path
          fill="url(#b)"
          d="M0-1h246l-60 214H0z"
          mask="url(#c)"
          opacity=".7"
        />
        <path fill="url(#d)" d="M-2 109h84L22 323H-2z" mask="url(#c)" />
      </g>
    </svg>
  </div>
);

export const TriangleSVG = ({ extraClasses, size = "small" }) => (
  <div
    role="img"
    className={`mls-o-svg transform ${extraClasses ? extraClasses : ""}`}
  >
    <span className={`oc-o-icon--triangle fa-icon-svg fa-icon-svg--${size}`}>
      <svg viewBox="0 0 4 6" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0v6.04l3.5-3.02z" fill="#FFF" fillRule="evenodd" />
      </svg>
    </span>
  </div>
);
